import { Text } from '@chakra-ui/react';

const LabelWithText = ({
  label,
  labelColor = 'brand.color_main',
  labelSize = 'xs',
  labelWeight,
  text,
  textSize = 'sm',
  as,
  mt,
  marginBottom,
  strikeLabel = false,
}) => {
  return (
    <>
      <Text color={labelColor} fontSize={labelSize} fontWeight={labelWeight} as={as} mt={mt} textDecoration={strikeLabel ? 'line-through' : null}>
        {label}
      </Text>
      <Text fontSize={textSize} as={as} marginBottom={marginBottom}>
        {text}
      </Text>
    </>
  );
};

export default LabelWithText;
